/*eslint-disable*/
import React from "react";

import '../../assets/styles/App.css';
import '../../assets/styles/tailwind.css';
import "@fontsource/montserrat";


export default function Terms() {
    window.scrollTo(0, 0);
    return (
        <>
            <div className="w-full px-4">
                <h1 className="hl-48 md:text-center mb-8">
                    TERMS OF USE
                </h1>
                <p className="text-16-150 mb-4">
                    These are the terms and conditions that apply when you access and use the capital portal at
                    https://capital-portal.jumo.world (the “Portal”).
                    These terms of use (“Terms”) apply between you and JUMO World Holding Limited
                    (registration number 176993/GBC) (“JUMO”, “we”, “our” or “us”) along with the other
                    legal documents that govern the Portal, being
                    the <a className="text-blue-link underline" target="_blank" href={'https://jumo.world/privacy-policy/'}>Privacy Policy</a> and <a className="text-blue-link underline" target="_blank" href={'https://jumo.world/cookie-policy/'}>Cookie Policy</a>.
                </p>
                <h2 className="text-24-500 mt-8 mb-4">
                    Important information
                </h2>
                <p className="text-16-150 mb-4">
                    Separate main agreement: Your access to the Portal has been granted because you, your employer,
                    or the entity which has engaged you (in each case your “Organisation”) has entered into a
                    written agreement with JUMO in terms of which (amongst other things) JUMO has expressly
                    provided your Organisation with access to the Portal (an “Investor Agreement”).
                    You agree to familiarise yourself with the Investor Agreement and to comply with all obligations
                    for staff and service providers as are set out in the Investor Agreement.
                </p>
                <p className="text-16-150 mb-4">
                    You may only access the Portal for as long as your Organisation continues to be party to an
                    Investor Agreement. If your Organisation is not, or ceases to be party to an Investor Agreement,
                    you agree to cease accessing the Portal and to delete any information you may have accessed via
                    the Portal save to the extent that the Investor Agreement permits you to retain such information.
                    In the event of any conflict between these Terms and the relevant Investor Agreement, the
                    Investor Agreement shall prevail to the extent of the conflict.
                </p>
                <h2 className="text-24-500 mt-8 mb-4">
                    Updates to Terms and Conditions and Withdrawal of Access
                </h2>
                <p className="text-16-150 mb-4">
                    These terms and conditions, and all policies on the Portal, govern your use of the Portal.
                    JUMO may change these terms and conditions, or any part of them, at any time. Each time you
                    sign in to or otherwise access or use this Portal you are entering into a new agreement with us
                    on the then applicable terms and conditions. Your continued use of the Portal indicates your
                    acceptance of the then prevailing terms and conditions. If you do not agree to be bound by the
                    terms and conditions you should discontinue use of this Portal.
                </p>
                <p className="text-16-150 mb-4">
                    Access to the Portal is on an as-is basis. JUMO may withdraw, suspend, refuse to offer or
                    refuse to make available the Portal, any feature of the Portal or any part of them to any
                    person or entity at any time and for any reason. JUMO is not required to notify you in respect
                    of any such action or provide you with any reasoning behind any decision.
                </p>
                <h2 className="text-24-500 mt-8 mb-4">
                    Website Registration
                </h2>
                <p className="text-16-150 mb-4">
                    You represent and warrant that all information you provide to register is complete, accurate and
                    not misleading, that you are over 18 years of age (or the age of majority in your country or state
                    of residence), that you or your Organisation is party to an Investor Agreement which grants access
                    to the Portal, and that you are fully competent to agree to these terms and conditions.
                    You agree that, should any changes occur that might affect your status, you shall immediately
                    provide us with such information via email to legalnotices@jumo.world. You represent and warrant
                    that your use of the Portal complies with all applicable laws, regulations, and sanctions
                    programs and other legal or government mandates.
                </p>
                <p className="text-16-150 mb-4">
                    You are responsible for the security of your account information and its contents (including,
                    but not limited to, your username and password). You agree and acknowledge that you are aware
                    of phishing and other privacy infringement attacks and will carefully review all communications
                    that appear to originate from us. JUMO is not responsible for any loss or damage that you may
                    incur due to your account or any of your hardware or software being compromised. If you suspect
                    that your account has been compromised, are uncertain about a communication that purports to
                    come from us or otherwise suspect illegitimate activity, you must immediately contact us on
                    +27 (0)21 344 1318 or by email to legalnotices@jumo.world.
                </p>
                <p className="text-16-150 mb-4">
                    This Portal may contain links to third-party sites and materials. These sites and materials may
                    not be controlled by us. Any third-party sites or materials are not endorsed by JUMO. JUMO is
                    not responsible for you accessing or relying on any third-party sites and materials.
                </p>
                <h2 className="text-24-500 mt-8 mb-4">
                    USE OF AND ACCESS TO THE PORTAL
                </h2>
                <p className="text-16-150 mb-4">
                    <strong>Information on the Portal</strong>: The information on this Portal is for your Organisation’s internal
                    business  use only as further set out in the Investor Agreement. You may not reverse engineer or
                    attempt to duplicate the functionality of the Portal or any information on the Portal; and save to
                    the extent expressly permitted in the Investor Agreement to the contrary, neither you nor your
                    Organisation may download, save, print, transmit, modify or copy all or any portion of the Portal,
                    or any information found on the Portal.
                </p>
                <p className="text-16-150 mb-4">
                    Should the Investor Agreement permit you to reproduce any content from the Portal, any such
                    reproduction must include the relevant copyright notice.
                </p>
                <p className="text-16-150 mb-4">
                    <strong>No offer to sell or solicitation</strong>
                </p>
                <p className="text-16-150 mb-4">
                    The information displayed on this website is for general informational purposes only and is not
                    an offer to sell or a solicitation of an offer to buy any investment, securities, options,
                    futures, or other derivatives related to securities in any jurisdiction and its content is not
                    prescribed by securities laws. Information contained on this website should not be relied upon
                    as advice to make any investment, buy or sell or hold such securities or as an offer to sell
                    such securities. The materials do not take into account nor do they provide any tax, legal or
                    investment advice or opinion regarding the specific investment objectives or financial situation
                    of any person. All prospective investors should make their own inquiries and consult their own
                    advisors as to legal, tax, investment, and related matters concerning an investment in JUMO.
                </p>
                <p className="text-16-150 mb-4">
                    The information contained on this website is intended for the registered user only. You should
                    not rely on it for investment analysis or any other purposes. While it is believed to be accurate
                    and reliable, JUMO and its agents, advisors, directors, officers and employees make no
                    representation or warranties, expressed or implied, as to the accuracy of such information and
                    JUMO expressly disclaims any and all liability that may be based on such information or errors
                    or omissions thereof. JUMO reserves the right to amend or replace the information contained herein,
                    in part or entirely, at any time, and undertakes no obligation to provide the recipient with
                    access to the amended information or to notify the recipient thereof. Neither JUMO nor any of
                    its representatives shall have any liability whatsoever, under contract, delict/tort or otherwise,
                    to you or any person resulting from the use of the information on this website by you or any of
                    your representatives or for omissions from the information on this website. It is your sole
                    responsibility to comply with any legislation in your jurisdiction relating to your use of
                    this website.
                </p>
                <h2 className="text-24-500 mt-8 mb-4">
                    PROHIBITED USE
                </h2>
                <p className="text-16-150">
                    You are not allowed to:
                </p>
                <p className="text-16-150">
                    <ul className="circle">
                        <li>introduce any materials that are designed to hamper the operations of the Portal
                            or its content;
                        </li>
                        <li>ddamage, disable, overburden, impair, or gain unauthorized access to the content
                            or the Portal;
                        </li>
                        <li>remove, modify, disable, block, obscure or otherwise impair any feature or information
                            displayed on, or used in connection with the Portal;
                        </li>
                        <li>use the Portal or the content to advertise or promote products or services that we
                            have not expressly approved in writing in advance;
                        </li>
                        <li>interfere with anyone else’s use and enjoyment of the Portal;
                        </li>
                        <li>attempt to discover or reverse engineer the source code and other materials forming
                            part of the technology used to provide the Portal or forming part of the content;
                        </li>
                        <li>share your login details or otherwise permit anyone else to access the Portal using
                            your login details;
                        </li>
                        <li>receive or charge money, favours or other consideration for allowing any other person
                            to use or access the Portal or the content.
                        </li>
                        <li>do anything that violates any of these Terms of Use;
                        </li>
                        <li>do anything which is illegal, fraudulent or violates or infringes any rights, title or
                            interest (including, any intellectual property rights) in or to this Portal or its content;
                        </li>
                        <li>deep link (link to any page other than the home page of this Portal) or link in any way
                            that could suggest that we endorse or support you or a third party, or that you have any
                            rights in our Portal or intellectual property, without our permission;
                        </li>
                        <li>remove, disable, bypass, or circumvent any protection mechanisms or access control
                            mechanisms on the Portal;
                        </li>
                        <li>use any technology (including spiders, crawlers, bots, and similar virtual agents) to
                            search or gain any information from this Portal, without our express prior
                            written permission;
                        </li>
                    </ul>
                </p>
                <h2 className="text-24-500 mt-8 mb-4">
                    INTELLECTUAL PROPERTY RIGHTS
                </h2>
                <p className="text-16-150 mb-4">
                    <strong>Ownership</strong>. JUMO owns all the intellectual property rights in the Portal and its
                    contents. These Terms do not grant you any right of ownership in any of the copyright, trademarks
                    and other intellectual property rights in and to the Portal and/or its contents.
                </p>
                <p className="text-16-150 mb-4">
                    <strong>Your rights</strong>. Your rights to use the Portal and its content are limited to those
                    that we give to you in these Terms.
                </p>
                <p className="text-16-150 mb-4">
                    <strong>No licence</strong>. Save as expressly agreed to the contrary in the Investor Agreement,
                    we do not grant you any licence or right to use any of our intellectual property, whether or
                    not found on the Portal, by virtue of your use of or access to the Portal.
                </p>
                <p className="text-16-150 mb-4">
                    The provisions of this clause (Intellectual Property Rights) will survive termination of these
                    Terms and/or the Investor Agreement.
                </p>
                <h2 className="text-24-500 mt-8 mb-4">
                    CONFIDENTIALITY
                </h2>
                <p className="text-16-150 mb-4">
                    The Portal and all information on the Portal is confidential and proprietary to JUMO. You agree
                    to keep the Portal and all information that you obtain from the Portal confidential, and not to
                    use or disclose it in any manner except as expressly permitted by the Partner Agreement.
                </p>
                <p className="text-16-150 mb-4">
                    You agree to keep your login details to the Portal secure and confidential and will be responsible
                    for any logins using your login details.
                </p>
                <p className="text-16-150 mb-4">
                    Your obligations in terms of this clause (Confidentiality) shall survive termination of these
                    Terms and/or the Investor Agreement for as long as you continue to have any access to the Portal
                    or continue to possess any information obtained from the Portal.
                </p>
                <h2 className="text-24-500 mt-8 mb-4">
                    THIRD PARTY WEBSITES AND MATERIAL
                </h2>
                <p className="text-16-150 mb-4">
                    <strong>No endorsement</strong>: Where we provide hypertext links to third-party internet websites,
                    these are not an endorsement by us of any products or services in such websites and we have not
                    verified the truth or accuracy of any content of such websites. You use such links entirely at
                    your own risk and we accept no responsibility or liability for the content, use or availability
                    of such websites.
                </p>
                <p className="text-16-150 mb-4">
                    <strong>Third party material</strong>: This Portal may also contain material provided by third
                    parties and we accept no responsibility or liability for the accuracy of such material.
                </p>
                <p className="text-16-150 mb-4">
                    <strong>No linking without consent</strong>: You are not permitted to link any other website to
                    this Portal without obtaining our prior written consent.
                </p>
                <h2 className="text-24-500 mt-8 mb-4">
                    PRIVACY
                </h2>
                <p className="text-16-150 mb-4">
                    Due to the confidential nature of the information on the Portal, you will be required to register
                    with your personal details before accessing most areas of the Portal.
                    If you register, you are indicating that you have read our <a className="text-blue-link underline" target="_blank" href={'https://jumo.world/privacy-policy/'}>Privacy Policy</a> and are willing for
                    us to deal with your personal data as set out in that policy.
                </p>
                <h2 className="text-24-500 mt-8 mb-4">
                    INTERNET COMMUNICATIONS
                </h2>
                <p className="text-16-150 mb-4">
                    We may monitor all internet communications, including web and email traffic into and out of
                    our domains for security, ensuring compliance with these Terms and detecting fraud and other
                    crimes.
                </p>
                <p className="text-16-150 mb-4">
                    <strong>No warranty of information</strong>
                </p>
                <p className="text-16-150 mb-4">
                    No warranty is given with respect to the adequacy or completeness of any disclosures or
                    information provided on this Portal or the fairness of the terms of any data presented for
                    information purposes herein. You may not rely on the financial assumptions or estimates that
                    are displayed on this Portal. Not all risks are disclosed on this Portal and risks will vary
                    depending on your circumstances. You should independently verify any information on this
                    Portal. JUMO shall have no liability to you for any decisions you take based on information
                    displayed on this Portal.
                </p>
                <p className="text-16-150 mb-4">
                    You warrant that you fully understand that past performance does not indicate future results
                    and that there can be no assurance that comparable results will be achieved. Any past
                    performance information is subject to, and should be reviewed in light of, the assumptions
                    accompanying that information. Forward-looking statements may be published on this Portal;
                    however, actual results may materially vary. JUMO undertakes no obligation to update or
                    review any information contained on this Portal, including any forward-looking statement.
                </p>
                <p className="text-16-150 mb-4">
                    Neither JUMO nor any of its directors, officers, employees, representatives, affiliates or
                    agents shall have any liability whatsoever arising from any error, inaccuracy or
                    incompleteness in any of the information, materials and communications on or through this
                    Portal. Some information on the Portal is in summary form for convenience of presentation
                    and may therefore not present comprehensive facts or data that may be relevant to you or
                    your comprehension or interpretation of the information. All data displayed on this Portal
                    relates to investments that are closed to new funding. Under no circumstances should any
                    information be used or considered as an offer to sell, or the invitation or solicitation
                    of an offer to buy, any investment listed on this Portal.
                </p>
                <p className="text-16-150 mb-4">
                    In particular, when considering the information displayed on this Portal, you should be
                    aware that:
                </p>
                <p className="text-16-150 mb-4">
                    JUMO is committed to responsible economic, social and governance (“ESG”) strategies.
                    JUMO may therefore take risks that are not consistent with non-ESG benchmarks. Demand
                    within certain markets or sectors that JUMO targets as part of its commitment to ESG may
                    not develop as forecasted or may develop more slowly than anticipated; and
                </p>
                <p className="text-16-150 mb-4">
                    Foreign and/or emerging markets investments may be volatile and illiquid, subject to
                    currency fluctuations and adverse economic or political developments (amongst other risks).
                </p>
                <p className="text-16-150 mb-4">
                    The above is not a comprehensive statement of risk factors. Any investment presents certain
                    risks and these risks will change depending on the identity and circumstances of the
                    investor. Investors must be able to afford to lose their entire investment.
                </p>
                <p className="text-16-150 mb-4">
                    <strong>Limitation of Liability</strong>
                </p>
                <p className="text-16-150 mb-4">
                    To the extent permitted under any applicable law, JUMO will not be responsible or liable to you
                    for any loss or damages of any kind, or for any direct, indirect, economic, exemplary, special,
                    punitive, incidental, or consequential losses or damages, that you may incur, including
                    (without limitation) arising out of (i) your use of the Portal; (ii) any non-performance,
                    defects in technical operation or downtime of the Portal; (iii) any virus or security breach;
                    or (iv) any investigations by a court or regulatory body.
                </p>
                <p className="text-16-150 mb-4">
                    <strong>Indemnity</strong>
                </p>
                <p className="text-16-150 mb-4">
                    By using and/or accessing the Portal, and by consenting to these terms and
                    conditions, you agree to indemnify and hold harmless JUMO from and against any and
                    all liabilities or damages that directly or indirectly arise from or are related
                    to (i) your failure to comply with these terms and conditions; (ii) your use of
                    the Portal and your activities in connection with website; and (iii) any
                    misrepresentation made by you.
                </p>
                <p className="text-16-150 mb-4">
                    <strong>Restrictions</strong>
                </p>
                <p className="text-16-150 mb-4">
                    Any unapproved or unpermitted use of the Portal is expressly prohibited. You are not
                    permitted to copy, distribute, share, publish, transmit, modify, reverse engineer or
                    otherwise reproduce or exploit any information provided herein, in whole or in part,
                    in any format to any third party without the express written consent of an authorised
                    representative of JUMO. In addition, you are not permitted to alter, obscure, or remove
                    any copyright, trademark or any other notices that are provided to you in connection with
                    the information.
                </p>
                <p className="text-16-150 mb-4">
                    <strong>Miscellaneous</strong>
                </p>
                <p className="text-16-150 mb-4">
                    These terms and conditions will be governed by and construed in accordance with Mauritian
                    law. Any matters or disputes in connection with or arising out of these Terms and/or your
                    access to or use of the Portal shall be decided by arbitration in terms of the Arbitration
                    Rules of the Mauritius International Arbitration Centre.
                </p>
                <p className="text-16-150 mb-4">
                    All provisions of these terms and conditions which, by their nature are continuing, will
                    survive termination of your agreement to these terms and conditions.
                </p>
                <p className="text-16-150 mb-4">
                    JUMO shall not be responsible for any failures or delays resulting from any situations beyond
                    our reasonable control.
                </p>
                <p className="text-16-150 mb-4">
                    In the event that any provision of these terms and conditions is held to be void or unenforceable
                    under applicable law, that provision will be severed and the remainder of these terms and
                    conditions will continue in full force and effect.
                </p>
                <p className="text-16-150 mb-4">
                    Any notice or communication that we provide to you will be deemed to be received 24 hours
                    after communicated to you, whether via the Portal or otherwise, and unless we receive a delivery
                    failure notification.
                </p>
            </div>
        </>
    );
}
